import { useMemo } from "react";

const ANONYMOUS_ID_KEY = "nextday:anonymous_id";

export const readOrCreateAnonymousId = (): string => {
  if (typeof window === "undefined") return "anon_ssr";
  try {
    const existing = window.localStorage.getItem(ANONYMOUS_ID_KEY);
    if (existing) return existing;
    const fresh = `anon_${crypto.randomUUID()}`;
    window.localStorage.setItem(ANONYMOUS_ID_KEY, fresh);
    return fresh;
  } catch {
    // Private mode / quota — fall back to a per-tab id. The session loses
    // resume across reload but the funnel still runs.
    return `anon_${crypto.randomUUID()}`;
  }
};

/** Sticky per-browser anonymous id used for variant bucketing + analytics. */
export const useAnonymousId = (): string => useMemo(readOrCreateAnonymousId, []);

export default useAnonymousId;
